import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const SeniorBoard = () => {
    useEffect(() => {
        document.title = 'Senior Board -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                <li>Prefectorial Board</li>
                 <li>Senior Board</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Senior School </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                <h6>Student Council 2025-26</h6>
                <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr> 
                          <th> Sl No</th>
                           <th> POST</th>
                           <th>NAME OF THE STUDENT </th>
                           <th>CLASS & SECTION</th>
                         </tr>
                   </thead>
                   <tbody> 
                   <tr><td>1</td><td>CAPTAIN – ARJAN HOUSE</td><td>AUDRIJAA GANGULY</td><td>11 E</td></tr>
    <tr><td>2</td><td>VICE CAPTAIN – ARJAN HOUSE</td><td>JOEL MADAN</td><td>11 C</td></tr>
    <tr><td>3</td><td>PREFECT – ARJAN HOUSE</td><td>ANIKA MATHUR</td><td>11 C</td></tr>
    <tr><td>4</td><td>PREFECT – ARJAN HOUSE</td><td>JASHANPREET SINGH</td><td>11 D</td></tr>
    <tr><td>5</td><td>CAPTAIN – KATRE HOUSE</td><td>GAYATRI MURLI</td><td>11 B</td></tr>
    <tr><td>6</td><td>VICE CAPTAIN – KATRE HOUSE</td><td>AARAV GUPTA</td><td>11 E</td></tr>
    <tr><td>7</td><td>PREFECT – KATRE HOUSE</td><td>AKSHAY KUMAR</td><td>11 B</td></tr>
    <tr><td>8</td><td>PREFECT – KATRE HOUSE</td><td>ARUNIMA BHAT</td><td>11 D</td></tr>
    <tr><td>9</td><td>CAPTAIN – LATIF HOUSE</td><td>RAGHAV SINGH CHIB</td><td>11 E</td></tr>
    <tr><td>10</td><td>VICE CAPTAIN – LATIF HOUSE</td><td>UDAIVEER SINGH RATHORE</td><td>11 A</td></tr>
    <tr><td>11</td><td>PREFECT – LATIF HOUSE</td><td>ARUSHI SINGH</td><td>11 B</td></tr>
    <tr><td>12</td><td>PREFECT – LATIF HOUSE</td><td>AARAV GUPTA</td><td>11 D</td></tr>
    <tr><td>13</td><td>CAPTAIN – PRATAP HOUSE</td><td>ABHIGYAN</td><td>11 E</td></tr>
    <tr><td>14</td><td>VICE CAPTAIN – PRATAP HOUSE</td><td>ANAGHA KASHYAP</td><td>11 E</td></tr>
    <tr><td>15</td><td>PREFECT – PRATAP HOUSE</td><td>SAUJANYA PADHY</td><td>11 B</td></tr>
    <tr><td>16</td><td>PREFECT – PRATAP HOUSE</td><td>GAYATRI RAHUL</td><td>11 E</td></tr>
    <tr><td>17</td><td>CAPTAIN – SUBROTO HOUSE</td><td>MANASVI VISWANATHAN</td><td>11 E</td></tr>
    <tr><td>18</td><td>VICE CAPTAIN – SUBROTO HOUSE</td><td>R RITHIKHA</td><td>11 B</td></tr>
    <tr><td>19</td><td>PREFECT – SUBROTO HOUSE</td><td>SHAURYA SINGH</td><td>11 D</td></tr>
    <tr><td>20</td><td>PREFECT – SUBROTO HOUSE</td><td>JAI VASHISHTH</td><td>11 E</td></tr>
    <tr><td>21</td><td>HEAD ACADEMICS</td><td>VIDHI SINGH</td><td>11 D</td></tr>
    <tr><td>22</td><td>PREFECT ACADEMICS</td><td>LAKSHYA GOEL</td><td>11 D</td></tr>
    <tr><td>23</td><td>PREFECT ACADEMICS</td><td>ANIKET MANDAR KOKATAY</td><td>11 E</td></tr>
    <tr><td>24</td><td>HEAD CO-CURRICULAR</td><td>UTSAV</td><td>11 D</td></tr>
    <tr><td>25</td><td>PREFECT CO-CURRICULAR</td><td>PURVI SINHA</td><td>11 A</td></tr>
    <tr><td>26</td><td>PREFECT CO-CURRICULAR</td><td>KRISHNA PANDEY</td><td>11 D</td></tr>
    <tr><td>27</td><td>HEAD DISCIPLINE (BOYS)</td><td>ANIMESH MANDAR KOKATAY</td><td>11 E</td></tr>
    <tr><td>28</td><td>HEAD DISCIPLINE (GIRLS)</td><td>ISHAA MISHRA</td><td>11 B</td></tr>
    <tr><td>29</td><td>PREFECT DISCIPLINE</td><td>VEDANSH VISHEN</td><td>11 B</td></tr>
    <tr><td>30</td><td>PREFECT DISCIPLINE</td><td>ARYAN DHIMAN</td><td>11 E</td></tr>
    <tr><td>31</td><td>PREFECT DISCIPLINE (SP. CHILD)</td><td>HARSHIT RAJPUT</td><td>11 A</td></tr>
    <tr><td>32</td><td>SPORTS CAPTAIN (BOYS)</td><td>RANVEER SINGH SIDHU</td><td>11 E</td></tr>
    <tr><td>33</td><td>SPORTS CAPTAIN (GIRLS)</td><td>PRIYANSHI</td><td>11 B</td></tr>
    <tr><td>34</td><td>SPORTS PREFECT</td><td>SANKALP ARUP BARUAH</td><td>11 B</td></tr>
    <tr><td>35</td><td>SPORTS PREFECT</td><td>DAKSHDEEP SINGH GILL</td><td>11 C</td></tr>
    <tr><td>36</td><td>HEAD JOURNALISM</td><td>BHUVANA THIMMAIAH</td><td>11 D</td></tr>
    <tr><td>37</td><td>PREFECT JOURNALISM</td><td>SIYA SINGH</td><td>11 C</td></tr>
    <tr><td>38</td><td>HEAD GIRL</td><td>MYRA BATRA</td><td>11 E</td></tr>
    <tr><td>39</td><td>HEAD BOY</td><td>SHAURYA SHARMA</td><td>11 E</td></tr>
    <tr><td>40</td><td>VICE HEAD GIRL</td><td>SALONI SINGH</td><td>11 E</td></tr>
    <tr><td>41</td><td>VICE HEAD BOY</td><td>KARTAVYA PANDEY</td><td>11 E</td></tr>
                   </tbody>
                 </table>
        </div>
         
                </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default SeniorBoard